import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Aboutus.css";
import AboutUsSingle from "./singleComponent/AboutUsSingle";

const Aboutus = () => {
  return (
    <Container id="about">
      <Row>
        <Col>
          <h1 className="about-h1-mini">O nas</h1>
          <h1 className="about-h1">
            O <span className="about-span">nas</span>
          </h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <AboutUsSingle
            title="Dawno temu"
            text="Firma została założona w 2018 roku z myślą o wspieraniu instytucji edukacyjnych 
            w zakresie nowoczesnych technologii. Od samego początku działalności naszym głównym celem 
            było świadczenie kompleksowych usług informatycznych, dostosowanych do specyfiki 
            i potrzeb polskich szkół."
            text_b="Specjalizujemy się w wdrażaniu i utrzymywaniu systemów
            informatycznych wspierających proces dydaktyczny oraz zarządzanie
            szkołą. Nasza oferta obejmuje m.in. administrację siecią szkolną,
            konfigurację i obsługę dzienników elektronicznych, tworzenie stron
            internetowych placówek, a także pomoc techniczną dla nauczycieli i
            uczniów."
          />
          <AboutUsSingle
            title="Nasza misja"
            text="Naszą misją jest wspieranie edukacji poprzez nowoczesne technologie,
            które ułatwiają nauczanie, usprawniają zarządzanie szkołą i
            sprzyjają rozwojowi kompetencji cyfrowych wśród uczniów i
            nauczycieli."
            text_b="Dzięki doświadczeniu zdobytemu w pracy z placówkami oświatowymi,
            rozumiemy wyzwania, przed którymi staje współczesna szkoła i
            potrafimy dostosować rozwiązania IT do realnych potrzeb
            użytkowników. Stawiamy na bezpieczeństwo, prostotę obsługi oraz
            niezawodność wdrażanych rozwiązań."
          />
          <AboutUsSingle
            title="Słuchamy naszych klientów"
            text="W odpowiedzi na rosnące potrzeby szkół i instytucji edukacyjnych, od
            2024 roku poszerzyliśmy swoją działalność o nową gałąź, dostarczanie blankietów szkolnych 
            oraz druków specjalistycznych (legitymacji)."
            text_b="Oferujemy m.in. świadectwa szkolne, legitymacje oraz inne dokumenty
            dostosowane do wymagań polskiego systemu oświaty. Nasze blankiety
            cechuje wysoka jakość wykonania, zgodność z obowiązującymi wzorami
            oraz możliwość indywidualnego dostosowania do potrzeb placówki.             
            Dzięki integracji usług informatycznych i drukarskich zapewniamy
            kompleksową obsługę szkół – od systemów zarządzania danymi uczniów
            po wydruk gotowych dokumentów. To nowoczesne i praktyczne
            rozwiązanie, które ułatwia codzienną pracę administracji szkolnej."
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Aboutus;
